import portsApi from '../framework/ports/portsApi';

export type ViewMode = 'sidebar' | 'mobile' | 'desktop';

const PromotionsFrontend = {
  startPromotions: (socketId: string, viewMode: ViewMode) => {
    return portsApi.invoke('Promotions.startPromotions', [socketId, viewMode]);
  },
  stopPromotions: () => portsApi.invoke('Promotions.stopPromotions'),
};

export default PromotionsFrontend;
